import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { getValueOrDefault } from '../helpers/getvalueOrDefault';

interface LoginQueryParams {
  idp?: string;
  username?: string;
  token?: string;
  schema?: string;
  isExport?: string;
  widget?: string;
  layout?: string;
  //yyyy-MM-dd
  to?: string;
  //yyyy-MM-dd
  from?: string;
  viewId?: string;
}

export const useLoginQueryParams = (): LoginQueryParams => {
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);

  const { idp, username, token, schema, isExport, widget, layout, to, from, viewId } = useMemo(() => {
    return {
      idp: getValueOrDefault(params.get('idp'), ''),
      username: getValueOrDefault(params.get('username'), ''),
      token: getValueOrDefault(decodeURIComponent(params.get('token') ?? ''), ''),
      schema: getValueOrDefault(params.get('schema'), ''),
      isExport: getValueOrDefault(params.get('export'), ''),
      layout: getValueOrDefault(params.get('layout'), ''),
      widget: getValueOrDefault(params.get('widget'), ''),
      to: getValueOrDefault(params.get('to'), ''),
      from: getValueOrDefault(params.get('from'), ''),
      viewId: getValueOrDefault(params.get('viewId'), ''),
    };
  }, [params]);

  return {
    idp,
    username,
    token,
    schema,
    isExport,
    widget,
    layout,
    to,
    from,
    viewId,
  };
};
